 /*
创建者 魏强(2018.1.29)
*/
<template>
    <div class="swipe">
        <Carousel
            v-model="value"
            :autoplay="setting.autoplay"
            :autoplay-speed="setting.autoplaySpeed"
            :dots="setting.dots"
            :radius-dot="setting.radiusDot"
            :trigger="setting.trigger"
            :arrow="setting.arrow"
        >
            <CarouselItem v-for="(item,index) in list" :key="index" >
                <router-link :to="item.to" target="_blank">
                    <img :src="item.atturl" height="218px" :alt="item.aname" width="432px" target="_blank" class="scrollLoading">
                </router-link>
            </CarouselItem>
        </Carousel>
    </div>
</template>
<script>
import {parseAdvList} from "utils/tool.js";
export default{
    props:["data"],
    data(){
        return {
            list:parseAdvList(this.data),
            value:0,
            setting: {
                autoplay: true,
                autoplaySpeed: 2000,
                dots: 'inside',
                radiusDot: true,
                trigger: 'hover',
                arrow: 'never'
            }
        }
    }
}
</script>



// WEBPACK FOOTER //
// list.vue?6d4af18f